import { useNavigate } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

/**
 * Vertical entry pillar card (Industrial Brutalism style)
 * Used in hero bento to link to each vertical: materials / spare_parts / machines
 */
export const VerticalPillarCard = ({
  label,
  title,
  description,
  accentColor,
  accentBg,
  accentText,
  icon: Icon,
  imageUrl,
  to,
  testId,
  metric,
}) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      data-testid={testId}
      className="group relative flex flex-col text-left w-full overflow-hidden border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 hover:border-[var(--accent-color)] dark:hover:border-[var(--accent-color)] transition-all duration-200 ease-out focus:outline-none focus:ring-2 focus:ring-[var(--accent-color)] focus:ring-offset-2 dark:focus:ring-offset-slate-950"
      style={{ '--accent-color': accentColor }}
    >
      {imageUrl && (
        <div className="relative h-28 md:h-32 w-full overflow-hidden bg-slate-100 dark:bg-slate-800">
          <img
            src={imageUrl}
            alt=""
            className="h-full w-full object-cover grayscale-[40%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
            loading="lazy"
          />
          <div
            className="absolute inset-0 mix-blend-multiply opacity-40 group-hover:opacity-0 transition-opacity duration-300"
            style={{ backgroundColor: accentColor }}
          />
        </div>
      )}
      <div className="flex-1 p-4 md:p-5 flex flex-col">
        <div className="flex items-center justify-between mb-2">
          <span
            className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.2em] px-2 py-0.5"
            style={{ backgroundColor: accentBg, color: accentText }}
          >
            <Icon className="h-3 w-3" />
            {label}
          </span>
          <ArrowUpRight
            className="h-4 w-4 text-slate-400 dark:text-slate-500 group-hover:text-[var(--accent-color)] dark:group-hover:text-[var(--accent-color)] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all duration-200"
          />
        </div>
        <h3 className="font-manrope text-base md:text-lg font-bold text-slate-900 dark:text-slate-50 tracking-tight leading-snug">
          {title}
        </h3>
        <p className="text-xs md:text-sm text-slate-600 dark:text-slate-400 mt-1 leading-relaxed">{description}</p>
        {metric && (
          <div className="mt-3 pt-3 border-t border-slate-100 dark:border-slate-800 flex items-baseline gap-1">
            <span className="font-mono text-lg font-bold text-slate-900 dark:text-slate-50 tabular-nums">{metric.value}</span>
            <span className="text-[10px] uppercase tracking-wider text-slate-500 dark:text-slate-400">{metric.label}</span>
          </div>
        )}
      </div>
    </button>
  );
};
